// Imports
import { useEffect, useState } from 'react';
import { faMagnifyingGlass, faGears, faHouseBuilding, faMessage, faSitemap } from '@fortawesome/pro-regular-svg-icons';
import adminUIActions from '../../shareables/foundation/admin-ui/redux/actions';
import { useAppDispatch } from '../../shareables/foundation/front-end/redux/hooks';
import { GetSelfResponse } from '../../shareables/types/api/main/self/get';
import apiActions from '../../shareables/integrations/api/redux/actions';


// Function component
const CustomizeUserDropdown: React.FC = () => {
	// Use state
	const [user, setUser] = useState<GetSelfResponse | null>(null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load user details on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetSelfResponse>({
				uri: `/self`,
				action: 'GET',
				completion: (json) => {
					setUser(json.response);
				},
			})
		);
	}, [dispatch, setUser]);
	
	
	// Replace the array of extra user dropdown items
	useEffect(() => {
		void dispatch(
			adminUIActions.replaceExtraUserDropdownItems([
				...(user?.preferenceID
					? [
							{
								type: 'anchor' as const,
								to: `https://preferences.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/?who=${window.encodeURIComponent(
									user.preferenceID
								)}`,
								content: 'Preferences',
								icon: faMessage,
								uniqueKey: 'preferences',
								target: '_blank',
							},
						]
					: []),
				...(user?.reseller
					? [
							{
								type: 'anchor' as const,
								to: `https://reseller.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`,
								content: 'Reseller Portal',
								icon: faSitemap,
								uniqueKey: 'reseller',
								target: '_blank',
							},
						]
					: []),
				{
					type: 'anchor',
					to: `https://app.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}`,
					content: 'My communities',
					icon: faHouseBuilding,
					uniqueKey: 'my-communities',
				},
				{
					type: 'link',
					to: '/website-review',
					content: 'Request a website review',
					icon: faMagnifyingGlass,
					uniqueKey: 'website-review',
				},
				{
					type: 'link',
					to: '/settings',
					content: 'Settings',
					icon: faGears,
					uniqueKey: 'settings',
				},
			])
		);
	}, [dispatch, user]);
	
	
	// Render nothing
	return null;
};

export default CustomizeUserDropdown;
